import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-skill-category-clothing",
  "use": "icon-skill-category-clothing-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-skill-category-clothing\">\r\n  <g fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\r\n    <path d=\"m8.5 3.5-2.75 1-3.5 4.25 3.25 2.5L7 9.5v11h10v-11l1.5 1.75 3.25-2.5-3.5-4.25-2.75-1a3.5 3.5 0 0 1-7 0Z\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol